module.exports = __webpack_public_path__ + "7fa82f4de62e48dc404a963704f31db6.jpg";